import useCallApi from '../../utilities/axios'

export function useDeleteOfficer() {
    const callApi = useCallApi()

    const deleteOfficer = async (userID: number | string) => {
        try {
            const { data } = await callApi.axiosDelete({
                url: `${process.env.REACT_APP_CU_IRB_API_URL}/users/officer/${userID}`,
                // params: null,
            })
            return { result: data }
        } catch (error) {
            return { error }
        }
    }

    return { deleteOfficer }
}
